/**
 * Utility functions for string manipulation
 */

/**
 * Converts a display string to a key format
 * Example: "Pet Name" -> "pet_name"
 * @param {string} displayString - The display string to convert
 * @returns {string} - The converted key string
 */
export const displayStringToKey = (displayString) => {
  if (!displayString || typeof displayString !== 'string') {
    return '';
  }
  
  return displayString
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/([^a-z0-9_])/g, '_$1_')  // Wrap special chars with underscores
    .replace(/_+/g, '_')  // Replace multiple consecutive underscores with single underscore
    .replace(/^_|_$/g, '');  // Trim leading and trailing underscores
};

/**
 * Converts a key string to a display format
 * Example: "pet_name" -> "Pet Name"
 * @param {string} keyString - The key string to convert
 * @returns {string} - The converted display string
 */
export const keyToDisplayString = (keyString) => {
  if (!keyString || typeof keyString !== 'string') {
    return '';
  }
  
  return keyString
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
